<template>
    <div class="paginator-container">
        <div class="paginator">
            <div class="paginator-info" v-if="!!total">
                {{ from }} - {{ to }} de {{ total }}
            </div>
            <div class="btn-group">
                <button class="btn btn-secondary" :disabled="currentPage === 1" @click="onChangePage(Math.max(1, currentPage - 1))"><i class="fa fa-angle-double-left"></i></button>
                <button 
                    class="btn" 
                    :class="{ 'btn-success': i === currentPage, 'btn-secondary': i !== currentPage }" 
                    @click="onChangePage(i)" 
                    :key="i" 
                    v-for="i in lastPage"
                    v-if="i >= firstPageToShow && i <= lastPageToShow">{{ i }}</button>
                <button class="btn btn-secondary" :disabled="currentPage === lastPage" @click="onChangePage(Math.min(lastPage, currentPage + 1))"><i class="fa fa-angle-double-right"></i></button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['currentPage', 'lastPage', 'from', 'to', 'total', 'per_page', 'onChangePage'],
        computed: {
            lastPageToShow(){
                return Math.min(this.lastPage, this.currentPage + 4);
            },
            firstPageToShow(){
                return Math.max(1, this.currentPage - 4);
            }
        }
    }
</script>